import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import { viTableClock } from "@sippy-platform/valkyrie";

import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

export default function TimetableCard({ timetable }) {
  return (
    <Card>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={`../timetable/${timetable.id}`}>
            <ListItemAvatar>
              <Avatar text={timetable.name} icon={viTableClock} />
            </ListItemAvatar>
            <ListItemText primary={timetable.name} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

TimetableCard.propTypes = {
  timetable: PropTypes.object,
};
